import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherCloudIcon width={12} />
 */
export const WeatherCloudIcon = props => (
    <SvgIcon {...props}>
        <path d="M6.275 19.9999C4.80833 19.9999 3.5625 19.4874 2.5375 18.4624C1.5125 17.4374 1 16.1916 1 14.7249C1 13.4249 1.41667 12.2832 2.25 11.2999C3.08333 10.3166 4.14167 9.7249 5.425 9.5249C5.75833 7.90824 6.54167 6.5874 7.775 5.5624C9.00833 4.5374 10.4333 4.0249 12.05 4.0249C13.9167 4.0249 15.4917 4.70407 16.775 6.0624C18.0583 7.42074 18.7 9.0499 18.7 10.9499V11.5499C19.9 11.5166 20.9167 11.9041 21.75 12.7124C22.5833 13.5207 23 14.5416 23 15.7749C23 16.9249 22.5833 17.9166 21.75 18.7499C20.9167 19.5832 19.925 19.9999 18.775 19.9999H6.275ZM6.275 18.4999H18.775C19.525 18.4999 20.1667 18.2332 20.7 17.6999C21.2333 17.1666 21.5 16.5249 21.5 15.7749C21.5 15.0249 21.2333 14.3832 20.7 13.8499C20.1667 13.3166 19.525 13.0499 18.775 13.0499H17.2V10.9499C17.2 9.43324 16.6917 8.1499 15.675 7.0999C14.6583 6.0499 13.4167 5.5249 11.95 5.5249C10.4833 5.5249 9.2375 6.0499 8.2125 7.0999C7.1875 8.1499 6.675 9.43324 6.675 10.9499H6.2C5.16667 10.9499 4.29167 11.3124 3.575 12.0374C2.85833 12.7624 2.5 13.6582 2.5 14.7249C2.5 15.7749 2.86667 16.6666 3.6 17.3999C4.33333 18.1332 5.225 18.4999 6.275 18.4999Z" />
    </SvgIcon>
)

WeatherCloudIcon.defaultProps = defaultProps
